mutation AttachPayCycleDocument($input: AttachPayCycleDocumentInput!) {
  attachPayCycleDocument(input: $input) {
    clientMutationId
    entityDocuments {
      id
      fileReference
    }
  }
}
